<template>


    <div class="py-4 px-5">

        <div class="form-group row">
            <div class="col-md-12">
                <p class="text-center">This section will be available within the settings section later on.</p>
            </div>
        </div>

        <div class="form-group row">
            <div class="col-sm-12 text-right mt-4">
                <button class="btn btn-secondary mr-3" v-on:click="previous">Previous</button>
                <button class="btn btn-primary" v-on:click="next">Next</button>
            </div>
        </div>

    </div>

</template>

<script>

    import { EventBus } from '../../utils/events'

	export default {
        name: 'Social',
		data () {
			return {
				msg: 'Welcome to Your Vue.js App'
			}
        },
        methods: {
            previous() {
                var data = {
                    at: 'about',
                    direction: 'backward',
                }
                EventBus.$emit('account-setup-navigation', data)
            },
            next() {
                var data = {
                    at: 'about',
                    direction: 'forward',
                }
                EventBus.$emit('account-setup-navigation', data)
            },
        }
    }

</script>



<style scoped>



</style>
